import React, { Component } from 'react';
import arrowNav from '../../assets/arrow-nav.png';

export default ({handleShow, isLogin, handleGetForum}) => {
  const imageSize = {
    height: 15,
    width: 15
  }
  return (
    <div className="col-lg-3 col-md-4 col-sm-12 col-12">
      <div className="card card-forum">
        <div className="card-header">Kategori Forum</div>
          <div className="card-body" style={{fontSize: '13px'}}>
            <div style={{color: '#0085C7', cursor: 'pointer'}} onClick={() => handleGetForum('/?category=Panduan Penggunaan')}>
              <div className="space-between">
                <p>Panduan Penggunaan</p>
                <img src={arrowNav} style={imageSize}/>
              </div>
            </div>
            <div style={{color: '#0085C7', cursor: 'pointer'}} onClick={() => handleGetForum('/?category=Perusahaan Penyelenggara')}>
              <div className="space-between">
                <p>Perusahaan Penyelenggara</p>
                <img src={arrowNav} style={imageSize} style={imageSize}/>
              </div>
            </div>
            <div style={{color: '#0085C7', cursor: 'pointer'}} onClick={() => handleGetForum('/?category=Event Kegiatan')}>
              <div className="space-between">
                <p>Event Kegiatan</p>
                <img src={arrowNav} style={imageSize}/>
              </div>
            </div>
            <div style={{color: '#0085C7', cursor: 'pointer'}} onClick={() => handleGetForum('/?category=Lain-lainnya')}>
              <div className="space-between">
                <p>Lain-lainnya</p>
                <img src={arrowNav} style={imageSize}/>
              </div>
            </div>
          </div>
        </div>
      <button className="btn btn-blue w-100 mt-3 mb-5" style={{padding: '10px 25px !important', display:'inline'}} onClick={() => handleShow('formForum')} >Buat Topik Forum</button>
    </div>
  )
}
